__turbopack_context__.v({
  "card": "styles-module__A3hQGa__card",
  "cardHeading": "styles-module__A3hQGa__cardHeading",
  "cards": "styles-module__A3hQGa__cards",
  "productGrid": "styles-module__A3hQGa__productGrid",
  "productHead": "styles-module__A3hQGa__productHead",
  "productLinks": "styles-module__A3hQGa__productLinks",
  "productName": "styles-module__A3hQGa__productName",
  "productSummary": "styles-module__A3hQGa__productSummary",
  "productTile": "styles-module__A3hQGa__productTile",
});
